import { Link } from "react-router-dom";
import { ArrowRightIcon } from "../../../../../components/icons";
import { cn } from "../../../../../utils/classnames";

/**
 * The gold "BOOK NOW" style button used by the hero cards and the closing
 * call to action. It is a link because it always takes the guest to another
 * page. Pass the width through `className` — the design uses 420px in the
 * heroes and 551px at the bottom of the Meet & Assist tab.
 */
export const GoldCtaLink = ({ to, label, className }) => (
  <Link
    to={to}
    className={cn(
      "tw:h-[50px] tw:w-full tw:px-8 tw:flex tw:items-center tw:justify-center tw:gap-x-[10px] tw:bg-[#D4B055] tw:hover:bg-[#b99844] tw:rounded-[5px] tw:!no-underline tw:transition tw:duration-200",
      className
    )}
  >
    <span className="tw:font-hanken-grotesk tw:font-bold tw:uppercase tw:text-[15px] tw:leading-[22px] tw:!text-white">
      {label}
    </span>
    <ArrowRightIcon color="#ffffff" size={20} />
  </Link>
);
